export default "__VITE_ASSET__BiyXZX8k__"